<div style="display: inline;block-size: 10%;">     
    <div class="row">    
    <div class="col-md-3" style="padding: 15px;">
          <h2 class="ng-binding" style="font-size: 30px;">HSN/SAC Codes</h2>
    </div> 
        <div class="col-md-9" (click)="AddHsnModel(mymodal, 0)" style="text-align: right; padding: 0px;">
            <span class="btn btn-orange" style="line-height: 33px !important;padding: 5px 10px;
            font-size: 13px !important;color:#fff;border: 1px solid #e88421; margin-top: 15px; background:#e88421;border-radius: 25px;padding: 0px 15px;">
            <span style="margin-right: 5px;">
            <i aria-hidden="true" class="zmdi zmdi-plus" style="font-size: 16px;position: relative;top: 1px;"></i></span>
            <span>Add</span></span>
        </div>
     </div>    
</div>

<div class="wrapper" style="width: 60%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"  #HSNCodetable>
    <table mat-table [dataSource]="dataSource">
     
      <ng-container matColumnDef="H">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>HSN No.</label>
        </th>
        <td mat-cell *matCellDef="let HSN" style="text-align: right; width: 10%;"> {{HSN.H}} </td>
      </ng-container>
      <ng-container matColumnDef="C">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label style="margin-left: 5px;"> Description</label>
        </th>
        <td mat-cell *matCellDef="let HSN">  {{HSN.C}}  </td>
      </ng-container>
    
      <!-- <ng-container matColumnDef="Category">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Category</label>
        </th>
        <td mat-cell *matCellDef="let element">  {{element.Category}} </td>
      </ng-container> -->

      <ng-container matColumnDef="Per">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>IGST Rate (%)</label>
        </th>
        <td mat-cell *matCellDef="let HSN" style="text-align: right; width: 10%;">  {{HSN.Per}} </td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element; let i =  index;" (click)="AddHsnModel(mymodal, element.HID)" style="width: 10px;">
          <div class="lableBtnOrange ng-scope" style="border-radius: 50%;">
            <i class="fa fa-pencil" aria-hidden="true"></i>
        </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element; let i = index;" (click)="deleteHSN(i)" style="width: 10px;"> 
          <div class="lableBtnGray inLneBlk" style="border-radius: 50%;">
            <i class="fa fa-trash" aria-hidden="true"></i>
        </div>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row;  columns: displayedColumns;"></tr>
    </table>
   <!-- Angular 8 pagination -->
   <mat-paginator
        [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
   </mat-paginator>
</div>

<!--Add HSN/SAC Codes-->
<ng-template #mymodal let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;padding-top: 5px !important;padding: 0px;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span> {{editIndex > -1 ? 'Edit HSN/SAC Codes' : 'Add HSN/SAC Codes'}}</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()" ></i>                       
                </div>
            </div>              
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div style="padding: 0px 15px 15px 15px;">
                <div class="col-md-6" style="padding: 0px; display: inline-block; width: 50% !important;">
                   <input [required]="required" style="width: 95%; text-align: right;" type="text" [(ngModel)]="data.H" class="form-control" maxlength="8" placeholder="HSN No."  (keypress)="numberOnly($event)">
                </div>
                <div class="col-md-6" style="padding: 0px; display: inline-block;">
                  <input style="width: 95%; text-align: right;" type="text" [(ngModel)]="data.Per" class="form-control" maxlength="3" placeholder="IGST Rate %"  (keypress)="numberOnly($event)">
                </div>
                <!-- <div class="col-md-6" style="padding: 0px; display: inline-block;"> 
                    <input class="form-control" list="selectcat" placeholder="Select category">
                    <datalist id="selectcat">
                      <option  value="product">product</option>
                      <option  value="service">service</option>
                    </datalist>
                </div> -->
              <div>
                 <input style="width: 100%; margin-top: 5px;" type="text" [(ngModel)]="data.C" class="form-control"  maxlength="50" placeholder="Description">
              </div> 
       </div>
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <span (click)="newHsn()" class="btn btn-save" style="padding: 5px 14px 4px; line-height: 1.66em;
             font-size: 14px;"><i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Save</span></span>
        </div>
    </div>
</ng-template>



